import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ColorPalette, E404, Home, MessagePage, Terms, Privacy } from "../pages";
import { UserContext } from "../context";

// logged-in users get their "My Space" landing page instead of the marketing home page
function HomeOrMySpace(): JSX.Element | null {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const loggedIn = !!user?.id;

  useEffect(() => {
    if (loggedIn) navigate("/myspace", { replace: true });
  }, [loggedIn, navigate]);

  return loggedIn ? null : <Home />;
}

export const generalRoutes = [
  { path: "/", element: <HomeOrMySpace /> },
  // explicit home page, always reachable (e.g. via the logo) even when logged in
  { path: "/home", element: <Home /> },
  { path: "message", element: <MessagePage /> },
  { path: "404", element: <E404 /> },
  { path: "colorpalette", element: <ColorPalette /> },
  { path: "/terms", element: <Terms />},
  { path: "/privacy", element: <Privacy />},
];
